import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Landing from "./components/landing/Landing";
import { getHomeRouteForUser } from "@/lib/routing";
import { useAuth } from "@/contexts/AuthContext";
import Loader from "./components/common/Loader";

export default function LandingContainer() {
  const { data: session, status } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status !== "authenticated" || !session) {
      return;
    }

    navigate(getHomeRouteForUser(session.user), { replace: true });
  }, [navigate, session, status]);

  if (status === "loading" || status === "authenticated") {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader />
      </div>
    );
  }

  return <Landing />;
}
